import { Swiper } from 'swiper';
// import { Autoplay } from 'swiper/modules';

//Swiper.use(Navigation);
// Swiper.use(Autoplay);
// Swiper.use(Scrollbar);

const navigation = (target) => {
    const swiperClass = {
      nextEl: `.${target}-swiper-controls__next`,
      prevEl: `.${target}-swiper-controls__prev`,
    };

    return swiperClass;
};

let swiper;

$(window).on('load', function () {
    if($('.partner-swiper').length) {
        swiper = new Swiper('.partner-swiper', {
            spaceBetween: 30,
            slidesPerView: 5,
            breakpoints: {
                994: {
                    slidesPerView: 5,
                },
                993: {
                    slidesPerView: 3.2,
                },
                0: {
                    slidesPerView: 1.4,
                },
            },
        });
    }
});

$(window).on('resize', function () {
    if (swiper) {
        swiper.update();
    }
});
